export enum DiscoveryUserMode {
  PROMPT = 'prompt',
  POSTS = 'posts',
}

export enum DiscoveryAssistantMode {
  SEARCH = 'search',
  SUGGESTION = 'suggestion',
  ANSWER = 'answer',
  FAILURE = 'failure',
  KEYWORD_SELECTION = 'keyword_selection',
  LOADING = 'loading',
}

export enum CREATOR_FILTER_DATE_RANGE {
  LAST_14_DAYS = '14d',
  LAST_30_DAYS = '30d',
  LAST_60_DAYS = '60d',
  ALL_TIME = 'all_time',
}
